// src/services/publicApi.js
import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const API_URL = getApiBaseUrl();

// Ajuste se seu back monta em /cardapio em vez de /manager/cardapio:
const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/cardapio';

// Instância pública (sem Authorization)
export const apiPublic = axios.create({
  baseURL: `${API_URL}${API_PREFIX}`,
  withCredentials: false,
});

export const criarComandaPublic = async (slug, payload) => {
  const { data } = await apiPublic.post(`/${slug}/comanda`, payload);
  return data;
};

export const getComandaPublic = async (slug, token) => {
  const { data } = await apiPublic.get(`/${slug}/comanda`, { params: { token } });
  return data;
};

export const fecharComandaPublic = async (slug, payload) => {
  const { data } = await apiPublic.put(`/${slug}/comanda/fechar`, payload);
  return data;
};

export const reabrirComandaPublic = async (slug, payload) => {
  const { data } = await apiPublic.put(`/${slug}/comanda/reabrir`, payload);
  return data;
};

// --------- RESTAURANTE ----------
export const getPublicRestaurante = async (slug) => {
  const { data } = await apiPublic.get(`/${slug}/restaurante`);
  return data?.data ?? data;
};

export const listPublicEnderecos = async (slug) => {
  const { data } = await apiPublic.get(`/${slug}/enderecos`);
  return data?.data ?? data ?? null;
};

// --------- CARDÁPIOS / CATEGORIAS / ITENS ----------
export const listPublicCardapios = async (slug, canal) => {
  const { data } = await apiPublic.get(`/${slug}/cardapios`, {
    params: canal ? { canal } : undefined,
  });
  return data?.data ?? data ?? [];
};

export const listPublicCategorias = async (slug, cardapioId, canal) => {
  const { data } = await apiPublic.get(`/${slug}/categorias`, {
    params: {
      cardapioId,
      ...(canal ? { canal } : {}),
    },
  });
  return data?.data ?? data ?? [];
};

export const listPublicItens = async (slug, categoriaId, canal) => {
  const { data } = await apiPublic.get(`/${slug}/itens`, {
    params: {
      categoriaId,
      ...(canal ? { canal } : {}),
    },
  });
  return data?.data ?? data ?? [];
};

// --------- TAGS ----------
export const listPublicTags = async (slug) => {
  const { data } = await apiPublic.get(`/${slug}/tags`);
  return data?.data ?? data ?? [];
};

export const listPublicItemTags = async (slug, itemId) => {
  const { data } = await apiPublic.get(`/${slug}/itens/${itemId}/tags`);
  return data?.data ?? [];
};

// --------- TRADUÇÕES ----------
export const listPublicCardapioTraducoes = async (slug, cardapioId) => {
  const { data } = await apiPublic.get(`/${slug}/cardapios/${cardapioId}/traducoes`);
  return data?.data ?? data ?? [];
};

export const listPublicCategoriaTraducoes = async (slug, categoriaId) => {
  const { data } = await apiPublic.get(`/${slug}/categorias/${categoriaId}/traducoes`);
  return data?.data ?? data ?? [];
};

export const listPublicItemTraducoes = async (slug, itemId) => {
  const { data } = await apiPublic.get(`/${slug}/itens/${itemId}/traducoes`);
  return data?.data ?? data ?? [];
};

// --------- COMPLEMENTOS ---------
export const listPublicItemComplementos = async (slug, itemId) => {
  const { data } = await apiPublic.get(`/${slug}/itens/${itemId}/complementos`);
  return data?.data ?? data ?? [];
};

export const listPublicItemOptionGroups = async (slug, itemId, canal = 'in_person') => {
  const { data } = await apiPublic.get(`/${slug}/itens/${itemId}/grupos-opcoes`, {
    params: { canal },
  });
  return data?.data ?? data ?? [];
};

// --------- PEDIDOS (público) ---------
export const criarOuObterPedidoPublic = async (slug, mesa) => {
  const { data } = await apiPublic.post(`/${slug}/pedidos`, mesa);
  return data?.data ?? data;
};

export const getPedidoPublic = async (slug, pedidoId) => {
  const { data } = await apiPublic.get(`/${slug}/pedidos/${pedidoId}`);
  return data?.data ?? data;
};

export const adicionarItemPedidoPublic = async (slug, pedidoId, payload) => {
  const { data } = await apiPublic.post(`/${slug}/pedidos/${pedidoId}/itens`, payload);
  return data?.data ?? data;
};

export const atualizarItemPedidoPublic = async (slug, pedidoId, pedidoItemId, payload) => {
  const { data } = await apiPublic.put(`/${slug}/pedidos/${pedidoId}/itens/${pedidoItemId}`, payload);
  return data?.data ?? data;
};

export const enviarPedidoPublic = async (slug, pedidoId) => {
  const { data } = await apiPublic.put(`/${slug}/pedidos/${pedidoId}/enviar`);
  return data?.data ?? data;
};

export const removerItemPedidoPublic = async (slug, pedidoId, pedidoItemId) => {
  const { data } = await apiPublic.delete(`/${slug}/pedidos/${pedidoId}/itens/${pedidoItemId}`);
  return data?.data ?? data;
};
